module.exports = __webpack_public_path__ + "static/media/www.k-ruoka.fi.market.079469bb.png";